import React from "react";
import { convertGridToPixels } from "../../Pages/FlexibleLayout/utils";
import PositionedScreen from "../../Pages/FlexibleLayout/PositionedScreen";
import RecordviewDesktopPreview from "../BuilderComponents/Preview/RecordviewDesktopPreview";
import { SCREEN_WIDTHS } from "../../constant/constant";

const RecordsViewPreview = ({ actualConfig }) => {
  // const { allApplicationBlockData } = useAppBlocksContext();

  // if (!config || !config.id) {
  //   console.error("Invalid config provided to RecordsViewPreview", config);
  //   return <div>Error: Invalid configuration</div>;
  // }

  // const recordsView = allApplicationBlockData?.[config.id];

  // if (!recordsView) {
  //   console.error(`Records view data not found for config ID: ${config.id}`);
  //   return <div>Error: Records view data not found</div>;
  // }

  const { device, is_positioned_block, position_block_config, position_block_metadata } = actualConfig;

  if (!device) {
    console.error("Device type is missing in records view data", actualConfig);
    return <div>Error: Device type missing</div>;
  }

  try {
    if (device === "desktop" || device === "tablet") {
      if (is_positioned_block) {
        return (
          <div className="overflow_hidden">
            <PositionedScreen
              layoutConfig={position_block_config || []}
              type={"view"}
              screenWidth={SCREEN_WIDTHS[device]}
            />
          </div>
        );
      } else {
        return <RecordviewDesktopPreview data={actualConfig} />;
      }
    } else if (device === "mobile") {
      if (is_positioned_block) {
        const gridSize = position_block_metadata?.grid_size || 4;
        const totalGrid = position_block_metadata?.total_grid || 128;

        return (
          <PositionedScreen
            layoutConfig={convertGridToPixels(position_block_config || [], gridSize)}
            screenWidth={gridSize * totalGrid || 512}
            type={"view"}
          />
        );
      }
      return <div>Mobile RecordsViewPreview</div>;
    }

    console.warn("Unknown device type encountered", device);
    return <div>Warning: Unknown device type</div>;
  } catch (error) {
    console.error("An error occurred while rendering RecordsViewPreview", error);
    return <div>Error: Failed to render records view preview</div>;
  }
};

export default RecordsViewPreview;
